import React, { lazy } from 'react';
import moment from 'moment';
import { hasValue } from 'globalutils/fmUtils';
import { UI_DATE_FORMAT_WITH_TIME_24 } from 'globalconfig/constants/static';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

export const generateRows = (logsHistory, viewReport) =>
  logsHistory?.dailyLogs?.map((item) => ({
    ...item,
    date: moment(new Date(item.date)).format(UI_DATE_FORMAT_WITH_TIME_24),
    pdf: item.reportId ? (
      <Link
        newPage
        onClick={() =>
          viewReport({
            apiId: 'viewReportApi',
            data: item.reportId,
          })
        }
      >
        {layout === 'SpireonNew' ? <SvgIcon value={mediaUrls.filePdfRegular} className="pdfIcon" /> : 'PDF'}
      </Link>
    ) : (
      ''
    ),
  })) || [];

export const generateColumns = (i18n) => [
  {
    id: 'version',
    numeric: true,
    disablePadding: true,
    label: 'common.version',
    needSorting: true,
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: 'common.date',
    needSorting: true,
  },
  {
    id: 'modifiedBy',
    numeric: false,
    disablePadding: false,
    label: 'common.modifiedBy',
    needSorting: true,
  },
  {
    id: 'comment',
    numeric: false,
    disablePadding: false,
    label: 'common.annotation',
    needSorting: true,
  },
  {
    id: 'pdf',
    label: i18n.t('Actions'),
    disablePadding: false,
    needSorting: true,
    numeric: false,
  },
];

export const getEmptyMessage = (apiStatus, apiId, i18n) => {
  const status = hasValue(apiStatus.status, 'api', apiId);
  return status?.errorMessage ? (
    <Message type="error" message={i18n.t(status.errorMessage)} />
  ) : (
    i18n.t('common.tableEmptyMessage')
  );
};
